import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";

const API = process.env.REACT_APP_API_URL;


function Login({ setIsLoggedIn }) {

  const navigate = useNavigate();

  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const userRef = useRef(null);

  useEffect(() => {
    userRef.current.focus();
  }, []);

  const handleLogin = async () => {

    if (!user || !pass) {
      setError("Please enter username and password");
      return;
    }

    setLoading(true);
    setError("");

    try {

      const res = await axios.post(`${API}/login`, { user, pass });


      if (res.data.status === "Success") {
        localStorage.setItem("loggedIn", "true");
        localStorage.setItem("token", res.data.token);

        // OPTIONAL (for UI only)
        const decoded = JSON.parse(atob(res.data.token.split(".")[1]));

        localStorage.setItem("role", decoded.role);

        // ✅ SAVE EXPIRY TIME
        localStorage.setItem("expiry", decoded.exp * 1000);

        setIsLoggedIn(true);
        navigate("/");
      } else {
        setError("Invalid username or password");
      }
    } catch (err) {
      setError("Server error. Try again.");
    }

    setLoading(false);
  };

  const handleKey = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  return (
    <div style={container}>

      <div style={card}>

        {/* 🏫 BRAND */}
        <img src={logo} alt="School Logo" style={logoStyle} />

        <h1 style={title}>Shiv Modern Academy</h1>
        <p style={subtitle}>School Management System</p>

        {/* ❌ ERROR */}
        {error && <div style={errorBox}>{error}</div>}

        {/* INPUTS */}
        <input
          ref={userRef}
          placeholder="Username"
          value={user}
          onChange={(e) => setUser(e.target.value)}
          onKeyDown={handleKey}
          style={input}
        />

        <input
          type="password"
          placeholder="Password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
          onKeyDown={handleKey}
          style={input}
        />

        {/* BUTTON */}
        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            ...button,
            opacity: loading ? 0.7 : 1
          }}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

      </div>
    </div>
  );
}

export default Login;

const container = {
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #1e3a8a, #2563eb)",
  fontFamily: "Segoe UI, sans-serif"
};

const card = {
  background: "#ffffff",
  padding: "40px",
  borderRadius: "16px",
  width: "360px",
  textAlign: "center",
  boxShadow: "0 15px 40px rgba(0,0,0,0.2)"  // stronger shadow
};

const title = {
  marginBottom: "5px",
  color: "#1e3a8a"
};

const subtitle = {
  marginBottom: "20px",
  color: "#6b7280",
  fontSize: "14px"
};

const input = {
  width: "100%",
  padding: "12px",
  marginBottom: "15px",
  borderRadius: "8px",
  border: "1px solid #d1d5db",
  outline: "none",
  fontSize: "14px",
  transition: "0.2s"
};

const button = {
  width: "100%",
  padding: "12px",
  background: "linear-gradient(135deg, #2563eb, #1e40af)", // 🔥 gradient
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "15px",
  transition: "0.2s"
};

const errorBox = {
  background: "#fee2e2",
  color: "#b91c1c",
  padding: "10px",
  marginBottom: "12px",
  borderRadius: "8px",
  fontSize: "13px"
};

const logoStyle = {
  width: "180px",
  height: "180px",
  objectFit: "contain",
  marginBottom: "10px"
};